import ColorRushContainer from './color-rush-container';
import { useFastLane } from '../store/index';
import { useMemo } from 'react';
import ColorRushSectionGroup from './color-rush-section-group';

export default function ColorRush() {
    const entries = useFastLane(f => f.entries);
    const colorRush = useFastLane(f => f.colorRush);
    const lastEntry = entries[entries.length - 1];

    const grouped = useMemo(() => {
        if (!entries) {
            return [];
        }

        return entries.reduce((acc, entry) => {
            const colorEntry = useFastLane.getState().getColorRushEntry(entry.index);

            if (!colorEntry) {
                return acc;
            }

            const lastGroup = acc?.[acc.length - 1] ?? null;

            if (
                lastGroup
                && lastGroup.color === colorEntry.color
                && lastGroup?.entries.find(i => i.index === (entry.index - 1))
            ) {
                return [
                    ...acc.slice(0, acc.length - 1),
                    {
                        ...lastGroup,
                        entries: [...lastGroup.entries, entry],
                    },
                ]
            } else {
                return [...acc, {
                    color: colorEntry.color,
                    includeOffset: colorEntry?.includeOffset ?? false,
                    entries: [entry],
                }];
            }
        }, []);
    }, [entries, colorRush]);

    if (!entries || lastEntry?.index === undefined) {
        return null;
    }

    return (
        <ColorRushContainer
            lastEntry={lastEntry}
        >
            {
                grouped.map((group, index) => (
                    <ColorRushSectionGroup
                        entries={group.entries}
                        color={group.color}
                        includeOffset={group.includeOffset}
                        key={index}
                    />
                ))
            }
        </ColorRushContainer>
    )
}
